import {
  createTheme,
  MantineTheme,
  MantineThemeOverride,
  rem,
} from "@mantine/core";
import {
  primary,
  gray,
  success,
  danger,
  warning,
  info,
} from "../constants/color-constants";

const theme: MantineThemeOverride = createTheme({
  fontFamily: "Roboto, sans-serif",

  colors: {
    primary,
    gray,
    success,
    danger,
    warning,
    info,
  },

  primaryColor: "primary",
  primaryShade: 4,

  shadows: {
    md: "1px 1px 3px rgba(0, 0, 0, .25)",
    xl: "5px 5px 3px rgba(0, 0, 0, .25)",
  },

  headings: {
    fontFamily: "Roboto, sans-serif",
    sizes: {
      h1: { fontSize: rem(36) },
    },
  },
}) as MantineTheme;

export default theme;
